export function showBackgroundImg(show) {
    return {
        type: "SHOW_BACKGROUND_IMG",
        showBackgroundImg: show
    };
}
